import React, { useState } from 'react';

const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const DAYS   = ['Su','Mo','Tu','We','Th','Fr','Sa'];

const fmtKey = (y, m, d) => `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

// Month-grid calendar. `counts` is keyed by 'YYYY-MM-DD' -> { events, accidents }.
// Clicking a day toggles it as the active date filter (click again to clear).
const EventsCalendar = ({ counts, selectedDate, onSelectDate }) => {
  const today = new Date();
  const initial = selectedDate ? new Date(`${selectedDate}T00:00:00`) : today;
  const [viewYear, setViewYear] = useState(initial.getFullYear());
  const [viewMonth, setViewMonth] = useState(initial.getMonth());

  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
  const firstDay = new Date(viewYear, viewMonth, 1).getDay();

  const prevMonth = () => { if (viewMonth === 0) { setViewMonth(11); setViewYear((y) => y - 1); } else setViewMonth((m) => m - 1); };
  const nextMonth = () => { if (viewMonth === 11) { setViewMonth(0); setViewYear((y) => y + 1); } else setViewMonth((m) => m + 1); };

  return (
    <div className="card">
      <div className="card-body" style={{ padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
          <button type="button" className="btn btn-ghost btn-xs" onClick={prevMonth}>←</button>
          <span style={{ fontWeight: 700, fontSize: 15, color: 'var(--text-1)' }}>{MONTHS[viewMonth]} {viewYear}</span>
          <button type="button" className="btn btn-ghost btn-xs" onClick={nextMonth}>→</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', marginBottom: 4 }}>
          {DAYS.map((d) => (
            <div key={d} style={{ textAlign: 'center', fontSize: 11, color: '#9ca3af', fontWeight: 600, padding: '4px 0' }}>{d}</div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
          {Array.from({ length: firstDay }).map((_, i) => (
            <div key={`p${i}`} style={{ minHeight: 52 }} />
          ))}

          {Array.from({ length: daysInMonth }, (_, i) => i + 1).map((day) => {
            const key = fmtKey(viewYear, viewMonth, day);
            const c = counts[key];
            const isToday = day === today.getDate() && viewMonth === today.getMonth() && viewYear === today.getFullYear();
            const isSel = selectedDate === key;
            return (
              <div
                key={day}
                onClick={() => onSelectDate(isSel ? null : key)}
                style={{
                  minHeight: 52, borderRadius: 8, padding: '6px 4px', cursor: 'pointer',
                  background: isSel ? '#0077b6' : (isToday ? '#eff6ff' : '#fff'),
                  border: `1px solid ${isSel ? '#0077b6' : '#f1f3f7'}`,
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                  transition: 'background 0.12s, border-color 0.12s',
                }}
              >
                <span style={{ fontSize: 13, fontWeight: isToday || isSel ? 700 : 500, color: isSel ? '#fff' : (isToday ? '#0077b6' : 'var(--text-1)') }}>
                  {day}
                </span>
                {c && (c.events > 0 || c.accidents > 0) && (
                  <div style={{ display: 'flex', gap: 3 }}>
                    {c.events > 0 && <span title={`${c.events} event(s)`} style={{ width: 6, height: 6, borderRadius: '50%', background: isSel ? '#fff' : '#3b82f6' }} />}
                    {c.accidents > 0 && <span title={`${c.accidents} accident(s)`} style={{ width: 6, height: 6, borderRadius: '50%', background: isSel ? '#fff' : '#ef4444' }} />}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ display: 'flex', gap: 16, marginTop: 14, paddingTop: 12, borderTop: '1px solid #f3f4f6', fontSize: 12, color: 'var(--text-3)' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: '#3b82f6', display: 'inline-block' }} /> Events</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', display: 'inline-block' }} /> Accidents</span>
          {selectedDate && (
            <button type="button" onClick={() => onSelectDate(null)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#0077b6', fontWeight: 600, cursor: 'pointer', fontSize: 12, padding: 0 }}>
              Clear date filter
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventsCalendar;
